import React from 'react';
import { FeaturePageLayout } from '../components/FeaturePageLayout';
import { RefreshCw, TrendingUp, Settings2, Maximize } from 'lucide-react';
export function RevampRepeat() {
  return <FeaturePageLayout hero={{
    badge: 'Step 7 of 7',
    h1: <>
            Revamp &{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal to-purple" data-id="element-2176">
              Repeat
            </span>
          </>,
    subtitle: 'Business evolves, and so should your AI. We continuously analyze performance data and refine agent behaviors to scale with your growth.'
  }} problem={{
    subtitle: 'The Stagnation Trap',
    cards: [{
      icon: <Settings2 className="w-6 h-6 text-teal" data-id="element-2177" />,
      title: 'Static Systems',
      desc: 'Traditional software implementations degrade over time as your business processes change and evolve.'
    }, {
      icon: <Maximize className="w-6 h-6 text-purple" data-id="element-2178" />,
      title: 'Scaling Bottlenecks',
      desc: 'What works for 100 customers might break when you scale to 1,000 without proper system adjustments.'
    }, {
      icon: <TrendingUp className="w-6 h-6 text-blue-400" data-id="element-2179" />,
      title: 'Missed Opportunities',
      desc: 'Failing to iterate means missing out on new AI capabilities and further optimization potential.'
    }]
  }} solution={{
    badge: 'The Evolution',
    title: 'Continuous Optimization',
    desc: 'Your AI infrastructure is a living system. We provide ongoing refinement to ensure it always operates at peak efficiency.',
    features: [{
      icon: <RefreshCw className="w-6 h-6 text-teal" data-id="element-2180" />,
      title: 'Iterative Refinement',
      desc: 'We use performance data to tweak prompts, adjust workflows, and improve agent accuracy over time.'
    }, {
      icon: <TrendingUp className="w-6 h-6 text-purple" data-id="element-2181" />,
      title: 'Scalable Growth',
      desc: 'As your business expands, we repeat the process to automate new departments and handle increased volume.'
    }]
  }} data-id="element-2175" />;
}